import { gql } from 'src/generated/gql';

export const INVITE_GUEST_PEER = gql(`
  mutation InviteGuestPeer($eventId: ID!, $reason: String!) {
    staff_inviteEventGuestPeer(eventId: $eventId, reason: $reason)
  }
`);
